/*
  Odenwälder BabyNest: Produktkarten
  1. Hover-Effekt (Zoom bzw. zweites Bild) nur, wenn die Maus über dem Bild ist, nicht über der
     ganzen Karte. Der Karten-Link liegt als Fläche über der ganzen Karte, deshalb reicht :hover
     am Bild nicht: Die Position wird gegen den Bildbereich geprüft (Klasse od-media-hover).
  2. Farbkreise: Beim Überfahren zeigt die Karte das Bild der Variante (data-od-preview-*),
     beim Verlassen der Farbkreise wieder das Originalbild (Klasse od-swatch-preview).
  Gilt für .card-wrapper (Produktkarten) und das Produktfeld im Grid (.od-grid__tile--product).
  Nur für Geräte mit Maus; Ereignisse per Delegation, funktioniert auch für nachgeladene Karten.
*/
(() => {
  if (window.odCardMediaInit) return;
  window.odCardMediaInit = true;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const CARD = '.card-wrapper, .od-grid__tile--product';
  const MEDIA = '.card__media, .od-grid__product-media';
  const IMAGE = '.card__media .media > img:first-child, .od-grid__product-image';

  // ---------- 1. Hover nur über dem Bild ----------
  let hoverCard = null;

  const setHover = (card, on) => {
    if (on) {
      if (hoverCard && hoverCard !== card) hoverCard.classList.remove('od-media-hover');
      card.classList.add('od-media-hover');
      hoverCard = card;
    } else if (card) {
      card.classList.remove('od-media-hover');
      if (hoverCard === card) hoverCard = null;
    }
  };

  document.addEventListener(
    'pointermove',
    (event) => {
      const card = event.target.closest && event.target.closest(CARD);
      if (!card) {
        if (hoverCard) setHover(hoverCard, false);
        return;
      }
      const media = card.querySelector(MEDIA);
      if (!media) return;
      const r = media.getBoundingClientRect();
      const inside =
        event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      setHover(card, inside);
    },
    { passive: true }
  );

  document.addEventListener('pointerleave', () => hoverCard && setHover(hoverCard, false));

  // ---------- 2. Variantenbild beim Überfahren der Farbkreise ----------
  const original = new WeakMap();

  const showPreview = (swatch) => {
    const card = swatch.closest(CARD);
    const img = card && card.querySelector(IMAGE);
    if (!img) return;
    if (!original.has(img)) {
      original.set(img, { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') });
    }
    img.setAttribute('srcset', swatch.dataset.odPreviewSrcset);
    img.setAttribute('src', swatch.dataset.odPreviewSrc);
    card.classList.add('od-swatch-preview');
  };

  const resetPreview = (card) => {
    const img = card && card.querySelector(IMAGE);
    if (!img || !original.has(img)) return;
    const o = original.get(img);
    if (o.srcset) img.setAttribute('srcset', o.srcset);
    else img.removeAttribute('srcset');
    if (o.src) img.setAttribute('src', o.src);
    original.delete(img);
    card.classList.remove('od-swatch-preview');
  };

  document.addEventListener('pointerover', (event) => {
    const swatch = event.target.closest && event.target.closest('[data-od-preview-src]');
    if (swatch) showPreview(swatch);
  });

  // Zurück erst beim Verlassen der ganzen Farbreihe, damit es zwischen zwei Kreisen nicht flackert
  document.addEventListener('pointerout', (event) => {
    const list = event.target.closest && event.target.closest('.od-card-swatches');
    if (!list) return;
    if (event.relatedTarget && list.contains(event.relatedTarget)) return;
    resetPreview(list.closest(CARD));
  });
})();
